<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New @entry-created="entryCreated" :modelNameSingular="modelNameSingular" />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit :entry="item" :readOnly="true" :modelNameSingular="modelNameSingular" />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag';
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Descrição", align: "left", sortable: true, value: "description" },
        { text: "Tipo", align: "left", sortable: true, value: "labelTypeText" },
        { text: "Nome da Cor", align: "left", sortable: false, value: "color.name" },
        { text: "Cor", align: "left", sortable: false, value: "colorHexaCode" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'colorHexaCode', mask: 'color'},
      ],
      infoHeaders: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["description"],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: []
    };
  },
  props: {
    modelNameSingular: { type: String, default: "Etiqueta" },
    modelNamePlural: { type: String, default: "Etiquetas" }
  },
  components: { BaseIndex, New, Edit, Delete },
  methods: {
    applyFilters(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries() {
      this.loading = true;
      this.$apollo.query({
        query: LOAD_ALL_LABELS,
        variables: {
          input: {
            limit: this.options.itemsPerPage,
            offset: (this.options.page - 1) * this.options.itemsPerPage,
            sortBy: this.options.sortBy,
            sortDesc: this.options.sortDesc,
            fields: this.tableHeaders.filter(header => header.sortable).map(header => header.value),
            filters: this.filters
          }
        },
        fetchPolicy: "no-cache"
      }).then(response => {
        const index = response.data.accountContext.labelsIndex;
        this.indexItems = index.labels;
        this.totalItems = index.count;
        this.typeOperators = index.typeOperators;
        this.serverFields = index.serverFields;
      }).catch(response => console.log(response)).finally(() => (this.loading = false));
    },
    entryUpdated() {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated() {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted() {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange(opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_LABELS = gql`
  query($input: IndexInputObject!) {
    accountContext {
      labelsIndex(input: $input) {
        count
        typeOperators
        serverFields
        labels {
          id
          description
          labelType
          labelTypeText
          color { id name hexaCode }
          colorHexaCode
          colorId
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;
</script>

<style scoped></style>